import {
  getCommonSetCropPledgeCreditorDto,
  getCommonUpdateCropPledgeCreditorInformationDto,
  getCommonUpdateCropPledgeDebtorInformationDto,
  getExplorerUpsertCropPledgeDocumentationDto,
  getExplorerUpsertCropPledgeLFarmInformationDto,
} from '@bcba/validators';

const _CommonUpdateCropPledgeDebtorInformationDto =
  getCommonUpdateCropPledgeDebtorInformationDto();

export class CommonUpdateCropPledgeDebtorInformationDto extends _CommonUpdateCropPledgeDebtorInformationDto {}

const _CommonUpdateCropPledgeCreditorInformationDto =
  getCommonUpdateCropPledgeCreditorInformationDto();

export class CommonUpdateCropPledgeCreditorInformationDto extends _CommonUpdateCropPledgeCreditorInformationDto {}

const _CommonSetCropPledgeCreditorDto = getCommonSetCropPledgeCreditorDto();

export class CommonSetCropPledgeCreditorDto extends _CommonSetCropPledgeCreditorDto {}

const _ExplorerUpsertCropPledgeFarmInformationDto =
  getExplorerUpsertCropPledgeLFarmInformationDto();

export class ExplorerUpsertCropPledgeFarmInformationDto extends _ExplorerUpsertCropPledgeFarmInformationDto {}

const _ExplorerUpsertCropPledgeDocumentationDto =
  getExplorerUpsertCropPledgeDocumentationDto();

export class ExplorerUpsertCropPledgeDocumentationDto extends _ExplorerUpsertCropPledgeDocumentationDto {}
